<div class="chart-wrapper">
  <div echarts [options]="chartOptions()" [merge]="chartOptions()" class="chart"></div>
</div>
